import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { ImgIcon, CheckBox } from ".";
import { add, reduce } from "./icons";

const returnCorrectNull = value => String(value === null ? 0 : value);

export default function QuantitySelector({
	value,
	onChange,
	min = 0,
	max = 9999999,
	className = "",
	showWhenDisabled = false,
	forceNumerical = true
}) {

	const [inputValue, setInputValue] = useState(returnCorrectNull(value));

	const canDecrease = value > min;
	const canIncrease = value < max;

	useEffect(() => {
		setInputValue(returnCorrectNull(value));
	}, [value]);

	return <div className={`quantitySelector featureFont v-middle ${className}`}>

		{max === 1  && !forceNumerical ?
			<>
				{/* When max is set to one, we're in single mode. */}
				<CheckBox
					size={25}
					checked={Boolean(value)}
					onChange={value => onChange(value ? 1 : 0)}
				/>
			</>
			:
			<>
				{/* Otherwise, multi mode. */}
				{(showWhenDisabled || canDecrease) && <ImgIcon
					src={reduce}
					size={30}
					iconSize="50%"
					className={`decrease normalFont ${canDecrease ? "" : "disabled"}`}
					onClick={canDecrease ? e => {
						if (value > 0) onChange(value - 1);
					} : null}
				/>}

				{Boolean(showWhenDisabled || value) && <input
					style={{
						minWidth: (value => value.length > 2 ? value.length * 10 : undefined)(String(inputValue))
					}}
					type="text"
					value={inputValue}
					onChange={e => setInputValue(e.target.value.replace(/[^\d]/g, ""))}
					onBlur={e => {
						let newVal = Number(e.target.value);
						if (isNaN(newVal)) return;
						if (newVal > max) newVal = max;
						if (newVal < min) newVal = min;
						if (newVal !== value) onChange(newVal);
						setInputValue(String(newVal));
					}}
					onFocus={e => {
						e.target.select();
					}}
				/>}

				{(showWhenDisabled || canIncrease) && <ImgIcon
					src={add}
					size={30}
					iconSize="50%"
					className={`increase normalFont ${canIncrease ? "" : "disabled"}`}
					onClick={canIncrease ? e => {
						if (value < max + 1) onChange(value + 1);
					} : null}
				/>}
			</>
		}
	</div>
}